<template>
  <div>
    <div
      ref="screenshotContainer"
      :style="getContainerStyle"/>
  </div>

</template>

<script>
export default {
  name:  'FilmStrip',
  props: {
    src:      String,
    maxWidth: {
      type:    Number,
      default: 500,
    },
    count: {
      type:    Number,
      default: 10,
    },
    height: {
      type:    Number,
      default: 65,
    },
    margin: {
      type:    Number,
      default: 5,
    },
    gap: {
      type:    Number,
      default: 2,
    },
  },
  data() {
    return {
      videoPlayer: null,
    };
  },
  computed: {
    getContainerStyle() {
      return { width: `${this.maxWidth}px`, height: `${this.height}px` };
    },
    getScreenShotWidth() {
      return this.maxWidth / this.count - this.gap;
    },
    getScreenShotHeight() {
      return this.height - (this.margin * 2);
    },
    getFrameInterval() {
      return this.duration / this.count;
    },
  },
  mounted() {
    const video        = document.createElement('video');
    video.src          = this.src;
    video.onseeked     = this.seekEnd;
    video.onloadeddata = this.initStrip;
    this.videoPlayer   = video;
  },
  methods: {
    initStrip() {
      try {
        this.duration                = this.videoPlayer.duration;
        this.videoPlayer.currentTime = this.getFrameInterval;
      } catch (ex) {
        console.log('video init failed with following message', ex.message);
      }
    },
    seekEnd(event) {
      this.captureFrame();
      const isValid = this.videoPlayer.currentTime + this.getFrameInterval;
      if (isValid <= this.videoPlayer.duration) {
        this.videoPlayer.currentTime += this.getFrameInterval;
      }
    },
    captureFrame() {
      try {
        const w             = this.getScreenShotWidth;
        const h             = this.getScreenShotHeight;
        const canvas        = document.createElement('canvas');
        canvas.width        = w;
        canvas.height       = h;
        canvas.style.margin = `${this.margin}px ${this.gap}px ${this.margin}px 0px `;
        canvas.classList.add('film-strip-canvas');
        const ctx = canvas.getContext('2d');

        const position = this.calculateFitToCoverPosition();
        ctx.drawImage(this.videoPlayer, position.offsetX, position.offsetY, position.width, position.height);
        this.$refs.screenshotContainer.appendChild(canvas);
      } catch (ex) {
        console.log('Frame capture failed with following message', ex.message);
      }
    },
    calculateFitToCoverPosition() {
      try {
        const childRatio  = this.videoPlayer.videoWidth / this.videoPlayer.videoHeight;
        const parentRatio = this.getScreenShotWidth / this.getScreenShotHeight;
        let width         = this.getScreenShotWidth * 1;
        let height        = this.getScreenShotHeight * 1;
        if (childRatio < parentRatio) {
          height = width / childRatio;
        } else {
          width = height * childRatio;
        }
        return {
          width, height, offsetX: (this.getScreenShotWidth - width) * 0.5, offsetY: (this.getScreenShotHeight - height) * 0.5,
        };
      } catch (ex) {
        console.log('cannot calculate optimal position', ex.message);
        return {
          width:   this.getScreenShotWidth, height:  this.getScreenShotHeight, offsetX: 0, offsetY: 0,
        };
      }
    },
  },
};
</script>

<style>
.film-strip-canvas{
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 5px;
  float:left;
  border-radius: 5px;
}
</style>
